import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div style={styles.container}>
      {/* NAV */}
      <nav style={styles.nav}>
        <img src="/logo.png" alt="logo" style={styles.logo} />

        <div>
          <Link to="/terms" style={styles.link}>Términos</Link>
          <Link to="/privacy" style={styles.link}>Privacidad</Link>
        </div>
      </nav>

      {/* HERO */}
      <section style={styles.hero}>
        <h1 style={styles.title}>
          Recorridos Virtuales para Bienes Raíces
        </h1>

        <p style={styles.subtitle}>
          Presenta propiedades con una experiencia moderna, clara y profesional.
        </p>

        <Link to="/tour/ejemplo" style={styles.cta}>
          Ver demo
        </Link>
      </section>

      {/* BENEFICIOS */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Por qué usar Korners</h2>

        <div style={styles.grid}>
          <div style={styles.card}>
            <h3>Experiencia Inmersiva</h3>
            <p>Recorridos 360° fluidos y de alta calidad</p>
          </div>

          <div style={styles.card}>
            <h3>Enfocado a Ventas</h3>
            <p>Mejora la presentación de tus propiedades</p>
          </div>

          <div style={styles.card}>
            <h3>Acceso Universal</h3>
            <p>Funciona en móvil, tablet y escritorio</p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <Link to="/terms" style={styles.footerLink}>Términos</Link>
        <Link to="/privacy" style={styles.footerLink}>Privacidad</Link>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "system-ui, sans-serif",
    color: "#111",

    /* 🔥 base con tinte verde */
    background: "linear-gradient(180deg, #f4f5f5 0%, #eef6f2 100%)",
    minHeight: "100vh",
  },

  nav: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 40px",

    /* 🟢 leve identidad */
    background: "rgba(250,252,251,0.9)",
    backdropFilter: "blur(6px)",
    borderBottom: "1px solid #e6eeea",
  },

  logo: { height: "40px" },

  link: {
    marginLeft: "20px",
    textDecoration: "none",
    color: "#0a7a5a",
    fontWeight: "500",
  },

  hero: {
    height: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "0 20px",

    /* 🎯 GRADIENTE VERDE SUAVE */
    background: "linear-gradient(180deg, #f9faf9 0%, #e8f5ef 100%)",
  },

  title: {
    fontSize: "42px",
    marginBottom: "20px",
    letterSpacing: "-0.3px",
  },

  subtitle: {
    maxWidth: "600px",
    color: "#4f5f5a",
    marginBottom: "30px",
  },

  cta: {
    padding: "12px 24px",
    borderRadius: "8px",

    /* 🟢 más presencia */
    background: "linear-gradient(135deg, #0a7a5a, #11a67a)",
    color: "#fff",
    textDecoration: "none",
    boxShadow: "0 6px 18px rgba(10,122,90,0.2)",
  },

  section: {
    padding: "80px 40px",
    textAlign: "center",

    /* 🔥 blanco con tinte verde */
    background: "#f7fbf9",
  },

  sectionTitle: {
    marginBottom: "40px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
  },

  card: {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "12px",

    /* 🟢 detalle premium */
    borderTop: "3px solid #0a7a5a",

    boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
  },

  footer: {
    padding: "30px",
    textAlign: "center",

    /* 🔽 cierre con verde */
    background: "linear-gradient(180deg, #edf5f1 0%, #e0efe8 100%)",
    borderTop: "1px solid #dfeae5",
  },

  footerLink: {
    margin: "0 10px",
    color: "#0a7a5a",
    textDecoration: "none",
  },
};